import UniversalSans600 from 'url:../../assets/fonts/UniversalSans-v1-2-50-100-0-713112212111-01-600.woff'
import UniversalSans900 from 'url:../../assets/fonts/UniversalSans-v1-2-50-100-0-713112212111-01-890.woff'
import SourceSans3Regular from 'url:../../assets/fonts/SourceSans3-Regular.ttf'
import InterRegular from 'url:../../assets/fonts/Inter-Regular.ttf'
import InterMedium from 'url:../../assets/fonts/Inter-Medium.ttf'
import InterSemiBold from 'url:../../assets/fonts/Inter-SemiBold.ttf'
import InterBold from 'url:../../assets/fonts/Inter-Bold.ttf'
import InterBlack from 'url:../../assets/fonts/Inter-900.ttf'
import RubikRegular from 'url:../../assets/fonts/Rubik-Regular.ttf'
import RubikSemiBold from 'url:../../assets/fonts/Rubik-SemiBold.ttf'
import RubikBold from 'url:../../assets/fonts/Rubik-Bold.ttf'
import { createGlobalStyle } from 'styled-components'
export const FontsStyle = createGlobalStyle`
@font-face {
  font-family: "UniversalSans600";
  font-weight: 600;
  font-style: normal;
  src: url(${UniversalSans600}) format("woff");
  font-display: swap;
}

@font-face {
  font-family: "UniversalSans900";
  font-weight: 900;
  font-style: normal;
  src: url(${UniversalSans900}) format("woff");
  font-display: swap;
}

@font-face {
  font-family: "SourceSans3";
  font-weight: 400;
  font-style: normal;
  src: url(${SourceSans3Regular}) format("truetype");
  font-display: swap;
}

@font-face {
  font-family: "Inter";
  font-weight: 400;
  font-style: normal;
  src: url(${InterRegular}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  font-weight: 500;
  font-style: normal;
  src: url(${InterMedium}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  font-weight: 600;
  font-style: normal;
  src: url(${InterSemiBold}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  font-weight: 700;
  font-style: normal;
  src: url(${InterBold}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  font-weight: 900;
  font-style: normal;
  src: url(${InterBlack}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Rubik";
  font-weight: 700;
  font-style: normal;
  src: url(${RubikBold}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Rubik";
  font-weight: 600;
  font-style: normal;
  src: url(${RubikSemiBold}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Rubik";
  font-weight: 400;
  font-style: normal;
  src: url(${RubikRegular}) format("truetype");
  font-display: swap;
}
`;
